if not App.angularApp?
    return

NUMBER_REGEXP = /^\-?(?:\d+\.?|\d*\.\d+)$/
DEFAULT_MAX = 1000000000

App.angularApp.directive 'mfIsLessThan', () ->
    return {
        require: 'ngModel'
        link: (scope, element, attrs, ngModel) =>

            # default max is 1 billion
            if attrs.mfIsLessThan
                max = attrs.mfIsLessThan
            else
                max = DEFAULT_MAX

            ngModel.$validators.mfIsLessThan = (modelValue, viewValue) =>
                if ngModel.$isEmpty(modelValue)
                    return true

                if NUMBER_REGEXP.test(viewValue) and viewValue < max
                    return true

                return false
    }
